import { render, staticRenderFns } from "./codeInput.vue?vue&type=template&id=3c10a6bf&scoped=true"
import script from "./codeInput.vue?vue&type=script&lang=js"
export * from "./codeInput.vue?vue&type=script&lang=js"
import style0 from "./codeInput.vue?vue&type=style&index=0&id=3c10a6bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c10a6bf",
  null
  
)

export default component.exports